import constant from '../../constant';
import request from '../../../utils/request';
import {  GET_SHORT_CONTENTS } from '../../../urls'
import { showTip } from '../../../utils'

const getShortContents = (params = {}, callback) => {
  return async (dispatch) => {

    try {
      const sDocId = params.sDocId
      if (sDocId) {  
        const res = await request.get(GET_SHORT_CONTENTS, {
          docId: sDocId
        })

        if (res.code === 0) {
          let docIdArr = []

          dispatch(getShortContentsSuccess(res.data))

          res.data.recommends.forEach((recommend) => {
            docIdArr.push(recommend.docId)
          })
          callback && callback(docIdArr || [])
        } else {
          showTip('内容跑丢了，重新试试呢')
        }
      } else {
        showTip('缺少必要参数 sDocId')
      }
  
    } catch (error) {
      console.log('getShortContents error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    } 
  }
}


const getShortContentsSuccess = (shortContents) => {
  return {
    type: constant.SHORT_CONTENT.CONTENT,
    shortContents
  }
}

export default {
  getShortContents,
  getShortContentsSuccess
}
